import * as d3 from 'd3';

import { LoggerFactory, ILogger } from '../../helpers/helpers';
import { IHorizontalLines } from './IHorizontalLines';
import { ResizableBase } from './ResizableBase';

export interface IHorizontalLineFormat {
    value: number;
    color: string;
    axis?: number | string;
    isHidden?: boolean;
    seriesId?: string | number;
}


export class HorizontalLines extends ResizableBase implements IHorizontalLines {
    private _originalContainer: d3.Selection<any>;
    private _horizontalLines: IHorizontalLineFormat[];
    private _width: number;
    private _height: number;
    private _scale: d3.scale.Linear<any, any>;
    private _logger: ILogger;
    private _isVisible = true;

    constructor(container: d3.Selection<any>, scale: d3.scale.Linear<any, any>, width: number, height: number) {
        super(container, 'horizontal-lines');
        this._logger = LoggerFactory.getLogger('WideTech.Charting.horizontalLines');
        this._originalContainer = container;
        this._width = width;
        this._height = height;
        this._scale = scale;
        this._horizontalLines = [];
    }

    private drawHorizontalLines() {
        try {
            const dataSelection = this.group()
                .selectAll('line')
                .data(this._horizontalLines);
            dataSelection.enter()
                .append('line')
                .classed('fixed-line', true);
            dataSelection
                .attr({
                    'x1': 0,
                    'x2': this._width,
                    'y1': (d) => this._scale(d.value),
                    'y2': (d) => this._scale(d.value)
                })
                .attr('data-axis', d => d.axis ? 'axis' + d.axis : null)
                .style({
                    'stroke': (d) => d.color,
                    'stroke-width': 1,
                    'stroke-dasharray': '5,2'
                })
                .classed('hidden-group', d => !!d.isHidden);
            dataSelection.exit().remove();
        } catch (e) {
            this._logger.error(e);
        }
    }

    resizeFunction(): (width: number, height: number) => void {
        const self = this;
        return (w, h) => {
            try {
                self._logger.info('Resize horizontal lines.');
                self._width = w;
                self._height = h;
                self._scale.range([h, 0]);
                self.drawHorizontalLines();
            } catch (e) {
                self._logger.error(e);
            }
        };
    }

    scale(value?: d3.scale.Linear<any, any>): d3.scale.Linear<any, any> {
        if (value) {
            this._scale = value;
            this.drawHorizontalLines();
        }
        return this._scale;
    }

    move(before: string): void {
        const toMove = this.group().remove();
        //Works but generates an error at compile time
        (<any>this._originalContainer).insert(() => toMove[0][0], before);
    }

    lines(value?: IHorizontalLineFormat[]): IHorizontalLineFormat[] {
        if (value) {
            this._horizontalLines = value;
            this.drawHorizontalLines();
        }
        return this._horizontalLines;
    }

    isVisible(value?: boolean): boolean {
        if (value !== null && value !== undefined) {
            this._isVisible = value;
            if (this._isVisible) {
                this.group().style({
                    'visibility': 'visible'
                });
            } else {
                this.group().style({
                    'visibility': 'hidden'
                });
            }
        }
        return this._isVisible;
    }
}